import React from 'react';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import {
    CalculateOutlined,
    DeleteOutline,
    FastfoodOutlined,
    PaymentsOutlined,
    ReceiptLongOutlined,
    Save as SaveIcon
} from '@mui/icons-material';
import { CartSummary } from '@api/ShoppingCart/ShoppingCart';

interface OrderTopBarProps {
    onToggleSavedOrders: () => void;
    onToggleCashFlow: () => void;
    onToggleExpenses: () => void;
    onSaveOrder: () => void;
    onClean: () => void;
    onShowTicket: () => void;
    shoppingCart?: CartSummary;
    showCashFlowCalculator: boolean;
    showExpenseRegister: boolean;
}

// Barra de arriba: solo lo que NO es del pedido (D3) — pedidos guardados, gastos,
// caja (ingresos y cobros), guardar, limpiar y recibo. La promoción se fue a `OrderActionsBar`, junto con
// las otras tres acciones del pedido.
export const OrderTopBar: React.FC<OrderTopBarProps> = ({
    onToggleSavedOrders,
    onToggleCashFlow,
    onToggleExpenses,
    onSaveOrder,
    onClean,
    onShowTicket,
    shoppingCart,
    showCashFlowCalculator,
    showExpenseRegister
}) => {
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Stack flex={1}>
                <Button onClick={onToggleSavedOrders} variant="text" startIcon={<FastfoodOutlined />}>
                    Pedidos guardados
                </Button>
            </Stack>

            <Stack flex={1} direction="row" justifyContent="flex-end" spacing={1}>
                <Tooltip title="Registro de gastos">
                    <IconButton onClick={onToggleExpenses} color={showExpenseRegister ? 'primary' : 'default'}>
                        <PaymentsOutlined fontSize="medium" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Ingresos y cobro de pedidos">
                    <IconButton onClick={onToggleCashFlow} color={showCashFlowCalculator ? 'primary' : 'default'}>
                        <CalculateOutlined fontSize="medium" />
                    </IconButton>
                </Tooltip>
                <IconButton disabled={!shoppingCart} onClick={onSaveOrder}>
                    <SaveIcon fontSize="medium" />
                </IconButton>
                <IconButton onClick={onClean}>
                    <DeleteOutline fontSize="medium" />
                </IconButton>
                <IconButton
                    disabled={!shoppingCart?.products || shoppingCart.products.length === 0}
                    onClick={onShowTicket}
                >
                    <ReceiptLongOutlined fontSize="medium" />
                </IconButton>
            </Stack>
        </Stack>
    );
};
